import Axios from "axios";
import config from "../app.config";

export default {
    getSubscriptions,
    getSubscriptionForCustomer,
    registerSubscription,
    confirmSubscription, 
    getListSubscriptions,
    createSubscriptions,
    showSubscriptions,
    updateSubscriptions,
    deleteSubscriptions
}

async function getSubscriptionForCustomer(payload) {
  return await Axios.post(`${config.LOCAL_API_URL}/subscription-customer`, payload)
    .then((response) => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response.data)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

async function registerSubscription(payload) {
  return await Axios.post(`${config.LOCAL_API_URL}/subscription-register`, payload)
    .then((response) => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response.data)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

async function confirmSubscription(payload) {
  return await Axios.post(`${config.LOCAL_API_URL}/subscription-confirm`, payload)
    .then((response) => {
      if (response.data.success || response.data.status) return Promise.resolve(response.data)
      else return Promise.reject(response.data)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

async function getListSubscriptions() {
    return await Axios.get(`${config.LOCAL_API_URL}/subscription-all`)
        .then(response => {
            if (response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error => {
            return Promise.reject(error);
        })
}

async function getSubscriptions(payload) {
    return await Axios.get(`${config.LOCAL_API_URL}/subscriptions`, {params: payload})
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error);
        })
}

async function createSubscriptions(params) {
    return await Axios.post(`${config.LOCAL_API_URL}/subscriptions`, params)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function showSubscriptions(id) {
    return await Axios.get(`${config.LOCAL_API_URL}/subscriptions/` + id)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function updateSubscriptions(data) {
    return await Axios.put(`${config.LOCAL_API_URL}/subscriptions/` + data.id, data)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function deleteSubscriptions(id) {
    return await Axios.delete(`${config.LOCAL_API_URL}/subscriptions/${id}`)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
